import { Avatar, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, InputAdornment, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, TextField } from "@material-ui/core";
import { Delete, Replay } from "@material-ui/icons";
import { Alert, Pagination } from "@material-ui/lab";
import moment from "moment";
import { useEffect, useState } from "react";
import { useFirestoreQuery } from "../../../firebase/hooks";
import { firestore } from "../../../helpers/firebaseHelper";
import { IsNullOrEmpty, paginate } from "../../../helpers/utility";
import firebase from 'firebase/app';
import $ from "jquery";
import Swal from "sweetalert2";
const pageSize = 10;

export default function LeadComments(props) {
    const { livestream, searchText, filter } = props;
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [showReply, setShowReply] = useState(false);
    const [showReplies, setShowReplies] = useState(false);
    const [reply, setReply] = useState("");
    const [replies, setReplies] = useState([]);
    const messagesRef = firestore.collection('messages');
    const messages1 = useFirestoreQuery(
        messagesRef.where("livestream", "==", livestream).orderBy('createdAt', 'desc').limit(1000)
    );

    const handleDelete = (st) => {
        Swal.fire({
            title: "Delete conversation",
            text: "Are you sure want delete this conversation",
            icon: "question",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            showConfirmButton: true,
            cancelButtonText: "Close",
            confirmButtonText: "Confirm",
            customClass: {
                cancelButton:
                    "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((x) => {
            if (x.isConfirmed) {
                messagesRef.doc(st.id).delete();
            }
        })

    }

    const handleReply = (st, v) => {
        debugger;
        messagesRef.doc(st.id).update({
            replies: st.replies ? [...st.replies, {
                text: v,
                createdAt: moment().unix(),
            }] : [{
                text: v,
                createdAt: moment().unix()
            }]
        }).finally(() => {
            setReply(false);
            setShowReply(false);
            $("#" + st.id).val("")
        })
    }

    useEffect(() => {
        setLoading(!loading)
    }, [messages1])

    let filteredList = messages1;

    if (!filteredList) {
        filteredList = [];
    }

    if (!IsNullOrEmpty(searchText)) {
        filteredList = filteredList.filter((x) =>
            x.displayName.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
            x.text.toLowerCase().indexOf(searchText.toLowerCase()) > -1);
    }

    if (!IsNullOrEmpty(filter)) {
        let startTime = moment().startOf('day');
        let endTime = moment().endOf('day');
        switch (filter) {
            case "Today":
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
            case "Week":
                startTime = moment().startOf("weeks");
                endTime = moment().endOf('weeks');
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
            case "Month":
                startTime = moment().startOf('month');
                endTime = moment().endOf('month');
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
            case "Year":
                startTime = moment().startOf('year');
                endTime = moment().endOf('year');
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
        }
    }

    let totalPages = Math.ceil(filteredList.length / pageSize);
    filteredList = paginate(filteredList, pageSize, page);
    return <Grid container className="mt-4">
        <Grid xs={12} sm={12}>
            <Grid container>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">
                    Date
                </Grid>
                <Grid item md={4} lg={4} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60  p-2">
                    Full Name
                </Grid>
                <Grid item md={4} lg={4} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">
                    Message
                </Grid>
                <Grid item md={2} lg={2} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">

                </Grid>
            </Grid>
        </Grid>
        <Grid xs={12} sm={12}>
            {
                filteredList && filteredList.map((st) => {

                    return <>
                        <Grid container>
                            <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex flex-align-center">
                                {moment.unix(st.createdAt.seconds).format("ll")}<br />
                                {moment.unix(st.createdAt.seconds).format("hh:mm:ss a")}
                            </Grid>
                            <Grid item md={4} lg={4} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                                <List disablePadding>
                                    <ListItem disableGutters className="p-0">
                                        <ListItemAvatar>
                                            <Avatar style={{ background: "transparent", border: "2px solid #E38301", color: "#E38301" }}>
                                                {st.photoURL ? <img src={st.photoURL} /> : st.displayName && st.displayName[0].toUpperCase()}
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={st.displayName} secondary={"@" + st.displayName} />
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid item md={4} lg={4} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                                {st.text}
                            </Grid>
                            <Grid item md={2} lg={2} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                                <Button
                                    className="text-black-60 "
                                    variant="outlined"
                                    color="secondary"
                                    style={{ minWidth: "unset" }}
                                    onClick={() => handleDelete(st)}
                                >
                                    <Delete />
                                </Button>
                            </Grid>
                            <Grid xs={12} sm={12} className="bg-white text-sm w-full">
                                <List>
                                    {
                                        st.replies && st.replies.map((x) => {
                                            return <ListItem className="pl-4 ml-4 text-black-60 ">
                                                <ListItemText primary={x.text} />
                                                <ListItemSecondaryAction className="pr-4">
                                                    {moment.unix(x.createdAt).format("lll")}
                                                </ListItemSecondaryAction>
                                                <Divider />
                                            </ListItem>
                                        })
                                    }
                                </List>
                                <div className="pl-4 mx-4 ">
                                    <TextField
                                        inputProps={{
                                            id: st.id
                                        }}
                                        minRows={2}
                                        multiline
                                        fullWidth
                                        variant="outlined"

                                        placeholder="Type reply here"
                                        InputProps={{
                                            endAdornment: <InputAdornment className="bg-info" position="end">
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => {
                                                        let val = $("#" + st.id).val();
                                                        const isEnabled = IsNullOrEmpty(val);
                                                        if (!isEnabled) {
                                                            handleReply(st, val);
                                                        }
                                                        else {
                                                            Swal.fire({
                                                                title: "Validation",
                                                                text: "Reply is required",
                                                                icon: "error"
                                                            })
                                                        }
                                                    }}>
                                                    Send
                                                </Button>
                                            </InputAdornment>
                                        }}
                                    />
                                </div>
                                <br />
                            </Grid>
                        </Grid>

                        <Divider />
                    </>
                })
            }
            {
                !loading && filteredList.length === 0 ?
                    IsNullOrEmpty(searchText) ?
                        <Alert severity="error" className="mt-4">No Chat leads available now</Alert> :
                        <Alert severity="error" className="mt-4">No Chat leads available for the selected criteria</Alert> :
                    ""
            }
            {
                loading && <Box display={"flex"} alignItems={"center"} justifyContent={"center"} className="m-4">
                    <CircularProgress />
                </Box>
            }
            <Dialog open={showReply} fullWidth maxWidth="md">
                <DialogTitle>
                    Send Reply
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <TextField
                        minRows={4}
                        multiline
                        value={reply}
                        onChange={(e) => setReply(e.target.value)}
                        fullWidth
                        variant="outlined"
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        className="text-black-60 "
                        variant="outlined"
                        color="secondary"
                        onClick={() => setShowReply(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="text-black-60 "
                        variant="outlined"
                        color="primary"
                        disabled={IsNullOrEmpty(reply)}
                        onClick={() => handleReply(selectedItem)}
                    >
                        Send
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showReplies} fullWidth maxWidth="md">
                <DialogTitle>
                    Replies
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <List>
                        {
                            replies.map((x) => {
                                return <ListItem>
                                    <ListItemText primary={x.text} secondary={moment.unix(x.createdAt).format("lll")} />
                                    <Divider />
                                </ListItem>
                            })
                        }
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="text-black-60 "
                        variant="outlined"
                        color="secondary"
                        onClick={() => setShowReplies(false)}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
        <Grid xs={12} sm={12}>
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} className="my-2">
                <Pagination
                    shape="rounded"
                    variant="outlined"
                    count={totalPages}
                    page={page}
                    color="primary"
                    onChange={(e, pg) => {
                        setPage(pg)
                    }} />
            </Box>
        </Grid>
    </Grid>
}